// Demo IDs for wallboard tour - use 999999xxx range
export const DEMO_WALLBOARD_MACHINE_ID = 999999100;

// Shared demo OEE value (raw 0-1; item.js multiplies by 100 → 72%)
export const DEMO_OEE_VALUE = 0.72;

// Tour target IDs for wallboard
export const WALLBOARD_TOUR_IDS = {
  MACHINE_TILE: 'wallboard-machine-tile',
  TILE_HEADER: 'wallboard-tile-header',
  PART_IMAGE: 'wallboard-part-image',
  PRODUCTIVITY_TIMELINE: 'wallboard-productivity-timeline',
  BATCH_TIMELINE: 'wallboard-batch-timeline',
  PIECES_PROGRESS: 'wallboard-pieces-progress',
  OEE_GAUGE: 'wallboard-oee-gauge',
  SCHEDULE_GAUGE: 'wallboard-schedule-gauge',
  LEVEL_SELECTOR: 'wallboard-level-selector',
  MACHINE_FILTER: 'wallboard-machine-filter',
} as const;
